export default __webpack_public_path__ + "static/media/drumpf-for-website.08d828de.png";